<template>
<div class="chapter">
<div class="inner_page">
<div class="div_autre">
<div class="pre" id="pre-003">
<h1 class="pre_tit"><span><a id="page_11">Chief abbreviations</a></span></h1><a id="page_11">
</a><div class="dev"><a id="page_11">
<div class="tableau" id="tab-001">
<div class="table-align">
<table border="0" cellpadding="2" cellspacing="0">
<colgroup>
<col width="20%"/>
<col/>
</colgroup>
<tbody>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>ANET</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Ancient Near Eastern Texts<sup>2</sup></i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>BASOR</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Bulletin of the American Schools of Oriental Research</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>BZAW</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Beihefte zum Zeitschrift für die alttestamentliche Wissenschaft</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>CBQ</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Catholic Biblical Quarterly</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>DJD</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Discoveries in the Judaean Desert</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify">E</p></td>
<td valign="top"><p class="txt_courant_justify">Elohistic source</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>HTR</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Harvard Theological Review</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>HUCA</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Hebrew Union College Annual</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>IBD</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>The Illustrated Bible Dictionary</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>IDB</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>The Interpreter’s Dictionary of the Bible</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>IDBS</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>The Interpreter’s Dictionary of the Bible</i>, Supplementary volume, 1976</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>IEJ</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Israel Exploration Journal</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify">J</p></td>
<td valign="top"><p class="txt_courant_justify">Yahwistic source</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>JAOS</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Journal of the American Oriental Society</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>JBL</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Journal of Biblical Literature</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>JJS</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Journal of Jewish Studies</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>JQR</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Jewish Quarterly Review</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>JSS</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Journal of Semitic Studies</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify">P</p></td>
<td valign="top"><p class="txt_courant_justify">Priestly source</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>PEQ</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Palestine Exploration Quarterly</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>RB</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Revue Biblique</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>TB</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Tyndale Bulletin</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><a id="page_12"><i>VT</i></a></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Vetus Testamentum</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>VTS</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Supplements to Vetus Testamentum</i></p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><i>ZAW</i></p></td>
<td valign="top"><p class="txt_courant_justify"><i>Zeitschrift für die alttestamentliche Wissenschaft</i></p></td>
</tr>
</tbody>
</table>
</div>
</div>
<div class="niv1" id="niv1-001">
<h2 class="int_niv1">Commentaries</h2>
<div class="tableau" id="tab-002">
<div class="table-align">
<table border="0" cellpadding="2" cellspacing="0">
<colgroup>
<col width="15%"/>
<col/>
</colgroup>
<tbody>
<tr valign="top">
<td valign="top"><p class="txt_courant">Baentsch</p></td>
<td valign="top"><p class="txt_courant"><i>Exodus, Leviticus, Numeri </i>by B. Baentsch (Hand-Kommentar zum Alten Testament), 1903.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Binns</p></td>
<td valign="top"><p class="txt_courant"><i>The Book of Numbers </i>by L. E. Binns (Westminster Commentaries), 1927.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Calvin</p></td>
<td valign="top"><p class="txt_courant"><i>Commentaries on the Four Last Books of Moses </i>by J. Calvin, 1563 (ET, 1852).</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Cazelles</p></td>
<td valign="top"><p class="txt_courant"><i>Les Nombres</i><sup>3</sup> by H. Cazelles (Bible de Jérusalem) 1971.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Dillmann</p></td>
<td valign="top"><p class="txt_courant"><i>Die Bücher Numeri, Deuteronomium und Josua </i><sup>2 </sup>by Dillmann (Kurzgefasstes exegetisches Handbuch zum Alten Testament), 1886.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Gispen</p></td>
<td valign="top"><p class="txt_courant"><i>Het boek Numeri I–II </i>by W. H. Gispen (Commentaar op het Oude Testament), 1959, 1964.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Gray</p></td>
<td valign="top"><p class="txt_courant"><i>A Critical and Exegetical Commentary on Numbers </i>by G. B. Gray (International Critical Commentary), 1903.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Greenstone</p></td>
<td valign="top"><p class="txt_courant"><i>Numbers with Commentary </i>by J. H. Greenstone (The Holy Scriptures), 1939.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Heinisch</p></td>
<td valign="top"><p class="txt_courant"><i>Das Buch Numeri übersetzt und erklärt </i>by P. Heinisch (Die heilige Schrift des Alten Testaments), 1936.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Keil</p></td>
<td valign="top"><p class="txt_courant"><i>The Pentateuch </i>III by C.F. Keil (Biblical Commentary on the Old Testament).</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Noordtzij</p></td>
<td valign="top"><p class="txt_courant"><i>Het boek Numeri </i>by A. Noordtzij (Korte Verklaring der Heilige Schrift), 1941.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Noth</p></td>
<td valign="top"><p class="txt_courant"><i>Numbers: A Commentary </i>by M. Noth (Old Testament Library), 1968.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Rashi</p></td>
<td valign="top"><p class="txt_courant"><i>Pentateuch with Rashi’s Commentary: Numbers </i>(ET by M. Rosenbaum and A.M. Silbermann).</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Saalschütz</p></td>
<td valign="top"><p class="txt_courant"><i>Das Mosaische Recht </i><sup>2</sup> by J. L. Saalschütz, 1853.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Snaith</p></td>
<td valign="top"><p class="txt_courant"><i>Leviticus and Numbers </i>by N.H. Snaith (New Century Bible), 1967.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Sturdy</p></td>
<td valign="top"><p class="txt_courant"><i>Numbers </i>by J. Sturdy (Cambridge Bible Commentary), 1976.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant"><a id="page_13">de Vaulx</a></p></td>
<td valign="top"><p class="txt_courant"><i>Les Nombres </i>by J. de Vaulx (Sources Bibliques), 1972.</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant">Wenham</p></td>
<td valign="top"><p class="txt_courant"><i>The Book of Leviticus </i>by G. J. Wenham (New International Commentary on the Old Testament), 1979.</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</a><div class="niv1" id="niv1-002"><a id="page_11">
</a><h2 class="int_niv1"><a id="page_11"></a><a id="page_15">Texts and versions</a></h2><a id="page_15">
<div class="tableau" id="tab-003">
<div class="table-align">
<table border="0" cellpadding="2" cellspacing="0">
<colgroup>
<col width="15%"/>
<col/>
</colgroup>
<tbody>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><span class="small">AV</span></p></td>
<td valign="top"><p class="txt_courant_justify">Authorized Version (King James)</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><span class="small">BHS</span></p></td>
<td valign="top"><p class="txt_courant_justify">Biblia Hebraica Stuttgartensia</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><span class="small">LXX</span></p></td>
<td valign="top"><p class="txt_courant_justify">The Septuagint (pre-Christian Greek version of OT)</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><span class="small">MT</span></p></td>
<td valign="top"><p class="txt_courant_justify">Massoretic Text</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><span class="small">NEB</span></p></td>
<td valign="top"><p class="txt_courant_justify">New English Bible</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><span class="small">NIV</span></p></td>
<td valign="top"><p class="txt_courant_justify">New International Version</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><span class="small">RSV</span></p></td>
<td valign="top"><p class="txt_courant_justify">Revised Standard Version</p></td>
</tr>
<tr valign="top">
<td valign="top"><p class="txt_courant_justify"><span class="small">TEV</span></p></td>
<td valign="top"><p class="txt_courant_justify">Today’s English Version</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</a></div><a id="page_15">
</a></div><a id="page_15">
</a></div><a id="page_15">
</a></div><a id="page_15">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre4.vue?908b1648